import { render, staticRenderFns } from "./ImageMetadata.vue?vue&type=template&id=3bae7f32&scoped=true"
import script from "./ImageMetadata.vue?vue&type=script&lang=js"
export * from "./ImageMetadata.vue?vue&type=script&lang=js"
import style0 from "./ImageMetadata.vue?vue&type=style&index=0&id=3bae7f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae7f32",
  null
  
)

export default component.exports